<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<template>
  <div
    class="d-flex align-center justify-center flex-column"
    style="height: 80vh;width: 100%"
  >
    <v-icon size="48">
      mdi-calendar-heart
    </v-icon>
    <div class="text-h4 mt-4 font-weight-bold">
      {{ $t('ThisMachineIsNotActivated', {itemName : productName}) }}
    </div>
    <div class="text-body-1 mt-1">
      {{ $t('ThisMachineIsNotActivatedHint', {itemName : productName})}}
    </div>
    <v-btn
      class=" mt-4  amber lighten-4 black--text"
      elevation="0"
      height="36"
      style="border-radius: 36px"
      @click="$emit('click')"
    >
      {{ $t('Activatefunction') }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'NotActivePage',
  props: {
    productName: {}
  }
}
</script>

<style scoped>

</style>
